module.exports = __webpack_public_path__ + "img/customMap.e0ce000.jpg";